module.exports = __webpack_public_path__ + "img/011.3e13c9aa.png";